export default __webpack_public_path__ + "static/media/fc8f3bfc85757d20ef798f82fe7ccf291598722034378.1fbefda2.webp";